// Browser PDF extractor using pdfjs-dist.
// Returns pages[] — same { s, x, y } shape that the bank parsers expect.
// Worker is served from /pdf.worker.min.mjs (copied to public/ at build time).
import { getDocument, GlobalWorkerOptions } from 'pdfjs-dist';

let configured = false;

function ensureWorker() {
  if (configured) return;
  GlobalWorkerOptions.workerSrc = '/pdf.worker.min.mjs';
  configured = true;
}

const isLatin = (s) => /[A-Za-z0-9]/.test(s) && !/[؀-ۿ]/.test(s);

export async function extractPages(file, password = '') {
  ensureWorker();
  const data = new Uint8Array(await file.arrayBuffer());

  let doc;
  try {
    doc = await getDocument({ data, password: password || '' }).promise;
  } catch (err) {
    if (err?.name === 'PasswordException' || err?.code === 1 || err?.code === 2) {
      throw new Error(
        password ? 'Wrong PDF password.' : 'PDF is password-protected — enter the password above.'
      );
    }
    throw err;
  }

  const pages = [];
  for (let p = 1; p <= doc.numPages; p++) {
    const page = await doc.getPage(p);
    const tc = await page.getTextContent();
    pages.push(
      tc.items
        .filter(i => i.str.trim() && isLatin(i.str))
        .map(i => ({
          s: i.str.trim(),
          x: Math.round(i.transform[4]),
          y: Math.round(i.transform[5]),
        }))
    );
  }

  return pages;
}
